export default __webpack_public_path__ + "static/media/FONDO.08c4ce05.png";